// PDP-only guard; Horizon remains responsible for fetching and updating variants.
function addSizeHelp(scope) {
  const legend = scope.querySelector('[data-nv-size-fieldset] legend');
  const source = scope.querySelector('.size-table__trigger');
  if (!legend || !source || legend.querySelector('.nv-size-help')) return;
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'nv-size-help';
  button.textContent = 'Jakou velikost vybrat?';
  button.addEventListener('click', () => source.click());
  legend.append(button);
  source.setAttribute('data-nv-relocated', '');
}
function initialize() {
  document.querySelectorAll('[data-nv-size-scope]').forEach(scope => {
    if (scope.dataset.nvSizeInitialized) return;
    scope.dataset.nvSizeInitialized = 'true';
    addSizeHelp(scope);
    scope.addEventListener('submit', event => {
      if (scope.hasAttribute('data-nv-size-pending') && event.target.closest('product-form-component')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        scope.querySelector('[data-nv-size-fieldset] input')?.focus();
      }
    }, true);
    scope.addEventListener('variant:update', event => {
      if (!event.target.matches('variant-picker[data-template-product-match="true"]')) return;
      if (event.detail.resource?.id) scope.removeAttribute('data-nv-size-pending');
      addSizeHelp(scope);
    });
  });
}
initialize();
document.addEventListener('shopify:section:load', initialize);
